<template>
  <div>
    <top-nav></top-nav>
    <div class="center_container">
      <div class="crumb">健身学习课程</div>

      <div class="filter_con">
        <div class="f_item">
          <div class="f_val">
            <div v-for="(item, index) in typeList" :key="index" :class="{'s_item': currentTypeIndex === index}"
                 class="v_item" @click="currentTypeIndex = index">
              {{ item }}
            </div>
          </div>
        </div>
      </div>

      <div class="s_list">
        <div v-for="item in courseList" :key="item.id" class="s_con">
          <div class="s_item">
            <div class="s_img">
              <img :src="require(`../../assets/image/course/c${item.id}.png`)" alt="">
            </div>
            <div class="s_info">
              <div>
                <div class="text_overflow s_name">{{ item.name }}</div>
                <div>发布时间：{{ item.date }}</div>
                <div class="s_type">{{ item.type }}</div>
              </div>
              <br>
              <el-button class="s_btn" type="primary" @click="toDetail">立即观看</el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="display_flex" style="justify-content: center">
        <el-pagination
            :total="100"
            background
            layout="prev, pager, next">
        </el-pagination>
      </div>
    </div>
    <bot-nav></bot-nav>
  </div>
</template>

<script>
export default {
  name: "fitnessLearningCourses",
  data () {
    return {
      typeList: ['全部', '运动方法', '运动营养', '大众运动', '技能学习', '家庭健身'],
      currentTypeIndex: 0,
      courseList: [
        { id: 1, name: '30分钟燃脂课程', date: '2023-08-23 09:00', type: '家庭健身' },
        { id: 2, name: '30分钟燃脂课程', date: '2023-08-23 09:00', type: '家庭健身' },
        { id: 3, name: '30分钟燃脂课程', date: '2023-08-23 09:00', type: '家庭健身' },
        { id: 4, name: '30分钟燃脂课程', date: '2023-08-23 09:00', type: '家庭健身' },
        { id: 5, name: '30分钟燃脂课程', date: '2023-08-23 09:00', type: '家庭健身' },
        { id: 6, name: '30分钟燃脂课程', date: '2023-08-23 09:00', type: '家庭健身' },
        { id: 7, name: '30分钟燃脂课程', date: '2023-08-23 09:00', type: '家庭健身' },
        { id: 8, name: '30分钟燃脂课程', date: '2023-08-23 09:00', type: '家庭健身' },
        { id: 9, name: '30分钟燃脂课程', date: '2023-08-23 09:00', type: '家庭健身' },
        { id: 10, name: '30分钟燃脂课程', date: '2023-08-23 09:00', type: '家庭健身' },
      ]
    }
  },
  methods: {
    toDetail () {
      this.$router.push('/courseDetail')
    }
  }
}
</script>

<style lang="less" scoped>
.center_container {
  padding-bottom: 30px;
}

.filter_con {
  border: none;
  margin-bottom: 0;
  padding: 0;

  .f_item {
    margin-bottom: 30px;
  }
}

.s_info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.s_type {
  margin-top: 8px;
}

.s_btn {
  width: 114px;
}
</style>
